module.exports = __webpack_public_path__ + "img/pic_deposit_success@2x.65c2f388.png";